<template>
  <div class="rating-card-list" :style="gridTemplateColumns">
    <div v-for="card in cardList" :key="card.id" class="rating-card-list__item">
      <Icon class="rating-card-list__icon" :icon="card.icon" />
      <div class="rating-card-list__content">
        <div class="rating-card-list__title">
          <div
            v-if="loading"
            class="ajax__line -round-"
            :style="{ height: '1em', width: '80px', margin: '2px 0' }"
          />
          <p v-else class="-no-wrap-">
            {{ card.title }}
          </p>
        </div>
        <p class="rating-card-list__description">
          {{ card.description }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cardList: {},
    loading: {
      type: Boolean,
      default: false
    },
    width: {},
    nameClass: {},
    titleClass: {}
  },
  computed: {
    gridTemplateColumns() {
      if (this.width !== null && this.width !== undefined) {
        return {
          gridTemplateColumns: `repeat(auto-fit, minmax(${this.width}, 1fr))`
        };
      }
      return undefined;
    }
  }
};
</script>
